import React from 'react'
import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import { router } from 'expo-router'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'

export default function AllDealsSection() {
  const { t } = useTranslation(['ui', 'intro'])
  const text = 'intro:sections.allDeals'

  const { animation, onPressIn, onPressOut } = useAnimatedPress()

  const onPress = () => router.navigate('/deals')

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          variant="small"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          classNameDesc="w-2/3 pr-12"
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            animation,
            image: require('@/images/deals-isometric-2.png'),
            imageWrapperStyle: {
              width: '90%',
              height: '90%',
            },
            imageStyle: {
              transform: [{ translateX: -10 }, { translateY: -10 }],
            },
            blur: Platform.select({ default: 100, web: 15 }),
            blurStyle: {
              opacity: Platform.select({ default: 0.25, web: 0.25 }),
              transform: [
                { translateX: Platform.select({ default: 0, web: 25 }) },
                { translateY: Platform.select({ default: 15, web: 40 }) },
                { scale: Platform.select({ default: 0.5, web: 0.5 }) },
              ],
            },
          }}
        />
      </Pressable>
    </>
  )
}
